<template>
  <div class="container" style="margin-top:30px;">
    <h3>Users</h3>
    <Table stripe :columns="columns" :data="users" style="margin-top:15px;"></Table>
  </div>
</template>

<script>
import {
  mapActions,
  mapGetters
} from 'vuex';
export default {
  data() {
    return {
      form: {},
      userForm: {},
      columns:[
        {
          title: 'Name',
          key: 'fullName',
          width: 200,
        },
        {
          title: 'Email',
          key: 'email',
        },
        {
          title: 'Role',
          key: 'role'
        },
        {
          title: 'Action',
          key: 'action',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                  props: {
                      type: 'primary',
                      size: 'small'
                  },
                  on: {
                      click: () => {
                          this.edit(params)
                      }
                  }
              }, 'Edit'),
              h('Button', {
                  props: {
                      type: 'error',
                      size: 'small'
                  },
                  on: {
                      click: () => {
                          this.delete(params)
                      }
                  }
              }, 'Delete')
            ]);
          }
        },
      ],
      tableData: [],
      isSaving: false,
    }
  },

  computed: {
    ...mapGetters('users', {
      findUsersInStore: 'find'
    }),
    users(){
      return this.findUsersInStore().data;
    }
  },
  methods: {
    ...mapActions('account', {
      createAccountAction: 'create',
      updateAccountAction: 'patch',
      getAccountAction: 'get'
    }),
    ...mapActions("users", {
      findUserAction: "find",
      deleteUserAction: "remove",
    }),
    delete(params){
      this.deleteUserAction(params.row._id);
    },
    edit(params){
      this.$router.replace("/user/"+params.row._id);
    }
  },
  created(){
    this.findUserAction();
  }
}
</script>

<style lang="scss">
.fullHeightTable{
  height: calc(100vh - 190px);

  .ivu-btn{
    margin-left: 8px;
  }
}
</style>
